// extracted by mini-css-extract-plugin
export default {"notification":"notification___ht257","hidden":"hidden___CODwA","shown":"shown___vnwZz","fadeIn":"fadeIn___tqPxn","btn":"btn___nN81u","btn_icon":"btn_icon___Ks4Jg"};